export default {
  statistics: {
    total_followers: 'Gesamtzahl der Follower',
    emails_sent: 'Gesendete E-Mails',
    emails_opened: 'Geöffnete E-Mails',
    emails_clicked: 'Geklickte E-Mails',
    emails_average_open_rate: 'E-Mail-Öffnungsrate',
    emails_average_click_rate: 'E-Mail-Klickrate',
    push_notifications_sent: 'Gesendete Push-Benachrichtigungen',
    push_notifications_clicked: 'Geklickte Push-Benachrichtigungen',
  },
};
